import styled, { css, keyframes } from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';
import { RADIUS } from '~/common/layout-propertis/radius';

const pulseScale = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

export const ClosePreviewWrapper = styled.div`
  position: absolute;
  right: 0;
  padding: 4px;
`;

export const PostPreview = styled.div<{
  visible: boolean;
}>`
  pointer-events: ${({ visible }) => (visible ? 'all' : 'none')};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: 200ms;
  position: fixed;
  width: 400px;
  max-height: 400px;
  overflow-y: scroll;
  scrollbar-width: thin;
  right: 0;
  bottom: 0;
  margin-bottom: 100px;
  margin-right: ${SPACING._20};
  background-color: ${({ theme }) => theme.neutral[900]};
  outline: 1px solid ${({ theme }) => theme.neutral[800]};
  border-radius: ${RADIUS._12};
  z-index: 12;

  > div {
    position: relative;
    height: 100%;
    width: 100%;

    #preview-content {
      padding: ${SPACING._16};
    }
  }
`;

export const AugustoInsightsContainer = styled.div<{
  highlight: boolean;
  offset: number;
}>`
  user-select: none;
  width: 75px;
  height: 75px;
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 20px;
  opacity: 0.5;
  transition: opacity 200ms;
  border-radius: 50%;
  transition: 100ms;
  cursor: pointer;
  z-index: 10;
  transform: ${({ offset }) => `translateX(-${offset}px)`};
  &:hover {
    opacity: 1;
  }

  img {
    border-radius: 50%;
  }

  ${({ highlight, theme }) =>
    highlight &&
    css`
      outline: 2px solid ${theme.green[500]};
      opacity: 1;
      /* Finito de propósito: animação infinita mantém o compositor da GPU
         ativo para sempre em todas as páginas (pesa em monitores hi-res). */
      animation: ${pulseScale} 1s 8 ease-in-out;
    `}
`;

export const PostsCount = styled.div<{
  visible: boolean;
}>`
  position: absolute;
  width: 16px;
  height: 16px;
  background-color: ${({ theme }) => theme.red[500]};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 7;
  border-radius: 50%;
  top: 0;
  right: 10px;
  transition: 200ms;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
`;
